import React from 'react';

const ScribbleUnderline = ({ color = '#2A5C8A', width = 180, className = '' }) => (
  <svg
    viewBox={`0 0 ${width} 10`}
    className={`w-full overflow-visible ${className}`}
    style={{ maxWidth: width }}
    preserveAspectRatio="none"
  >
    <path
      d={`M2,7 C${width*0.15},3 ${width*0.3},9 ${width*0.5},5 C${width*0.7},1 ${width*0.85},8 ${width-2},5`}
      fill="none"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeDasharray="800"
      strokeDashoffset="0"
      className="animate-scribble"
    />
  </svg>
);

export default ScribbleUnderline;